import React from 'react'
import PropTypes from 'prop-types'
import { withTheme } from 'react-jss'
import { Link } from 'react-router-dom'

import buttonLinkStyles from './link-button-style'

const LinkButton = props => {
  const classes = buttonLinkStyles(props.theme)
  const buttonProps = {
    className: classes.buttonLink,
    onClick: props.onClick,
  }

  if (props.to) {
    return (
      <Link to={props.to} {...buttonProps}>
        {props.children}
      </Link>
    )
  }

  return (
    <button type={props.type} {...buttonProps}>
      {props.children}
    </button>
  )
}

LinkButton.propTypes = {
  type: PropTypes.string,
  children: PropTypes.node.isRequired,
  theme: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  to: PropTypes.string,
}

LinkButton.defaultProps = {
  type: 'button',
}

export default withTheme(LinkButton)
